export default {
  agreeToTerms: "By signing up, you agree to the {{terms}} and {{privacy}}",
  agreeToTermsLogin:
    "By logging in, you agree to the {{terms}} and {{privacy}}",
  alreadyHaveAnAccountLoginIn: "Already have an account? {{login}}",
  createAnAccount: "Create an account",
  email: "Email",
  twoFaCode: "Two Factor Authentication Code",
  twoFaTitle: "Two Factor Authentication",
  twoFaDescription: "Enter the code from your authenticator app",
  confirmDisableTwoFaTitle: "Disable Two Factor Authentication",
  confirmDisableMessage:
    "Are you sure you want to disable two factor authentication?",
  loading: "Loading...",
  logIn: "Log In",
  logIntoYourAccount: "Log into your account",
  newToInvup: "New to invup? {{signUp}}",
  or: "or",
  password: "Password",
  privacyPolicy: "Privacy Policy",
  signUp: "Sign Up",
  startUsingInvupForFree: "Create an account to start using invup for free",
  termsAndConditions: "Terms and Conditions",
  forgotPassword: "Forgot password?",
  requestAPasswordReset: "Request a password reset",
  requestPasswordResetMessage:
    "Enter your email to receive a password reset link",
  resetPassword: "Reset Password",
  newPassword: "New Password",
  confirmPassword: "Confirm Password",
  passwordResetSuccess: "Your password has been reset successfully.",
  passwordResetSuccessTitle: "Password reset",
  passwordResetContinue: "Continue",
  passwordResetError:
    "There was an error resetting your password. Please try again.",
  submit: "Submit",
  verifyYourEmail: "Verify Your Email",
  verifyEmailMessage:
    "We sent you an email with a verification link. Please check your inbox and click on the link to verify your email address.",
  verifyEmailSpamMessage:
    "If you don't see the email, please check your spam folder or click the button below to resend the verification email.",
  resendVerificationEmail: "Resend Verification Email",
  pleaseWaitBeforeResending:
    "Please wait {{seconds}} seconds before resending.",
  verifyEmailError:
    "There was an error verifying your email. Please try again.",
  invalidEmailVerificationLink: "Invalid email verification link.",
  continueWithGoogle: "Continue with Google",
  continueWithGithub: "Continue with GitHub",
  continueWithEmail: "Continue with Email",
  orDivider: "or",
  logout: "Logout",
  socialAuthErrorAccessDenied: "You cancelled the sign in. Please try again.",
  socialAuthErrorInvalidCode: "Authentication failed. Please try again.",
  socialAuthErrorInvalidState:
    "Authentication session expired. Please try again.",
  socialAuthErrorInvalidProvider: "Invalid authentication provider.",
  socialAuthErrorAccountDisabled:
    "Your account has been disabled. Please contact support.",
  socialAuthErrorInvitationFailed:
    "Unable to accept the invitation. The invitation may have expired or is no longer valid.",
  socialAuthErrorAuthFailed: "Sign in failed. Please try again.",
  socialAuthErrorGeneric: "An error occurred during sign in. Please try again.",
};
